import { faClipboardCheck } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';

export const NoResultEmptyState = () => (
  <EmptyStateContainer>
    <EmptyState
      image={<EmptyStateIcon icon={faClipboardCheck} />}
      title={<FormattedMessage id="home.empty.title" />}
      message={<FormattedMessage id="home.empty.message" />}
      secondaryCTA={
        <EmptyState.CallToAction.Secondary
          href="https://www.rocketlane.com/"
          target="_blank"
        >
          <FormattedMessage id="home.empty.secondary" />
        </EmptyState.CallToAction.Secondary>
      }
    />
  </EmptyStateContainer>
);
